"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const StyledItemContainer = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "Item__StyledItemContainer",
  componentId: "components-web__sc-1rfdaul-0"
})({
  display: 'inline-block',
  paddingLeft: _ref => {
    let {
      listItemPadding
    } = _ref;
    return `${listItemPadding}px`;
  },
  lineHeight: _ref2 => {
    let {
      lineHeight,
      fontSize
    } = _ref2;
    return `${Math.ceil(lineHeight * fontSize)}px`;
  },
  marginBottom: '8px'
});
const IconContainer = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "Item__IconContainer",
  componentId: "components-web__sc-1rfdaul-1"
})({
  display: 'inline-block',
  paddingLeft: _ref3 => {
    let {
      iconPadding
    } = _ref3;
    return `${iconPadding}px`;
  },
  paddingRight: _ref4 => {
    let {
      iconPadding
    } = _ref4;
    return `${iconPadding}px`;
  },
  fontFamily: _ref5 => {
    let {
      fontName,
      fontWeight
    } = _ref5;
    return (0, _componentsBase.applyTextStyles)({
      fontName,
      fontWeight
    }).fontFamily;
  },
  height: _ref6 => {
    let {
      iconContainerSize
    } = _ref6;
    return `${iconContainerSize}px`;
  },
  width: _ref7 => {
    let {
      iconContainerSize,
      iconPadding
    } = _ref7;
    return `${iconContainerSize + iconPadding * 2}px`;
  },
  verticalAlign: 'bottom'
});
const Item = /*#__PURE__*/_react.default.forwardRef((_ref8, ref) => {
  let {
    href,
    children,
    current = false,
    tokens,
    variant = {
      light: true
    },
    // `light` variant (shared with the `Link` component) is default by design
    LinkRouter,
    linkRouterProps,
    onPress,
    ...rest
  } = _ref8;
  const {
    iconColor,
    icon: ChevronRightIcon,
    currentColor,
    color,
    iconSize,
    fontSize,
    fontWeight,
    fontName,
    lineHeight,
    listItemPadding,
    iconContainerSize,
    iconPadding
  } = (0, _componentsBase.useThemeTokens)('Breadcrumbs', tokens, variant);
  const linkOptions = {
    ..._componentsBase.clickProps.toPressProps(selectProps(rest)),
    href
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledItemContainer, {
    listItemPadding: listItemPadding,
    lineHeight: lineHeight,
    fontSize: fontSize,
    iconContainerSize: iconContainerSize,
    children: current ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      tokens: {
        color: currentColor,
        fontSize,
        fontWeight,
        lineHeight
      },
      variant: variant,
      children: children
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Link, {
        ...linkOptions,
        ref: ref,
        tokens: {
          color,
          blockFontSize: fontSize,
          blockLineHeight: lineHeight
        },
        LinkRouter: LinkRouter,
        linkRouterProps: linkRouterProps,
        variant: variant,
        onPress: onPress,
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(IconContainer, {
        iconPadding: iconPadding,
        fontName: fontName,
        fontWeight: fontWeight,
        iconContainerSize: iconContainerSize,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ChevronRightIcon, {
          size: iconSize,
          color: iconColor
        })
      })]
    })
  });
});
Item.displayName = 'Item';
Item.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Breadcrumb text
   */
  children: _propTypes.default.node.isRequired,
  /**
   * @ignore
   *
   * Indicates whether or not the Item should be as current/active
   */
  current: _propTypes.default.bool,
  /**
   * Target URL. This will be converted to `to` if the `LinkRouter`
   * prop is provided to the `Item` or parent `Breadcrumbs` element.
   */
  href: _propTypes.default.string.isRequired,
  /**
   * Variant to render.
   */
  variant: _propTypes.default.shape({
    inverse: _propTypes.default.bool
  }),
  /**
   * Function to be called when the Item is clicked.
   */
  onPress: _propTypes.default.func
};
var _default = exports.default = Item;